import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Robustere Defaults: 30s staleTime + 5min gcTime, 2 Retries mit
      // exponentiellem Backoff (max 30s). Verhindert "ein Netz-Glitch ->
      // dauerhaft leerer Error-Screen" fuer alle Nicht-Auth-Queries; der
      // /api/auth/me-Sonderfall (retry: 4) in AuthProvider ueberschreibt das lokal.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
    },
  },
});

// Separater QueryClient fuer /admin (genestet ueber AdminQueryScope).
//
// Warum: Das Admin-Panel ist explizit "online-only" — kein Dexie-Cache,
// kein Persist-Layer, keine offline-Reads. Wenn der Admin offline ist,
// will er sofort einen Lade-Fehler sehen statt veraltete Daten. Ausserdem
// darf nichts aus dem Admin-Bereich im globalen Client-Cache zurueckbleiben,
// wenn der Tab verlassen oder ausgeloggt wird (siehe AdminQueryScope).
//
// networkMode:'online' verhindert, dass useQuery ueberhaupt startet, wenn
// der Browser offline ist (statt erst zu fetchen und dann zu failen).
export const adminQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'online',
      gcTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: 2,
    },
    mutations: {
      networkMode: 'online',
    },
  },
});